import { useState, useContext } from "react";
import context from "../../store/context";

import PreferanceForm from "../section/PreferanceForm";

import noPreferance from "../../assets/programmer.svg";
import zigzagArrow from "../../assets/trend.png";
import AuthenticationButton from "../Buttons/AuthenticationButton";

const NoPreferance = () => {
  const {
    preferance,
    fetchData,
    getCategories,
    getLanguagesAndRegions,
    getPopularCategories,
  } = useContext(context);
  const [showUpdatePreferance, setShowUpdatePreferance] = useState(false);

  const handleGetStarted = () => {
    setShowUpdatePreferance(true);
  };

  const fetchNewData = () => {
    fetchData();
    getCategories("myfeed");
    getLanguagesAndRegions("myfeed");
    getPopularCategories("myfeed");
  };
  return (
    <>
      {preferance ? (
        showUpdatePreferance ? (
          <div className="w-[95%] max-w-[500px] p-5 sm:p-8 text-[#3d5984] bg-white drop-shadow mt-[20%] md:mt-[10%] rounded-md">
            <PreferanceForm onResponse={fetchNewData} showHeader={true} />
          </div>
        ) : (
          <div className="w-[95%] max-w-[480px] p-6 sm:p-8 text-[#3d5984] bg-white border border-gray-100 shadow-[0_4px_20px_rgba(61,89,132,0.1)] mt-[20%] md:mt-[10%] rounded-2xl flex flex-col items-center text-center gap-5">
            <h1 className="font-semibold text-lg md:text-xl">
              Tenders, <span className="text-[#664bc7]">For You</span>.
            </h1>
            <p className="text-sm text-gray-500 leading-relaxed">
              Personalize your tender viewing experience by configuring your
              settings and viewing only the tenders that are relevant and
              important to you.
            </p>
            <div className="w-24 h-24 md:w-32 md:h-32">
              <img src={noPreferance} alt="no saved tenders" />
            </div>
            <div className="w-full flex flex-col items-center gap-3">
              <p className="text-sm text-gray-500 leading-relaxed">
                To ensure you receive the most relevant tenders, update your
                preference now. It'll only take a few seconds!
              </p>
              <img
                className="w-8 rotate-[130deg]"
                src={zigzagArrow}
                alt="zig zar arrow"
              />
              <AuthenticationButton
                onClick={handleGetStarted}
                className="w-full h-12 bg-[#664bc7] hover:bg-[#664bc7]/90 text-white rounded-xl font-semibold transition-colors relative overflow-hidden"
                name="Get Started"
              />
            </div>
          </div>
        )
      ) : (
        <div className="mt-[20%] md:mt-[10%] bg-white shadow p-8 rounded-md">
          <h1>No Result</h1>
        </div>
      )}
    </>
  );
};

export default NoPreferance;
